import { render } from "./UiTimePicker.vue?vue&type=template&id=5c06d795"
import script from "./UiTimePicker.vue?vue&type=script&lang=js"
export * from "./UiTimePicker.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__